import React from "react";

const Footer = () => {
    return (
        <React.Fragment>
        <footer className="page-footer">
			<p className="mb-0">Copyright © 2023. All right reserved.</p>
		</footer>
        </React.Fragment>
    )
}

export default Footer